import { render, staticRenderFns } from "./BoardDetail.vue?vue&type=template&id=19be47a3&scoped=true&"
import script from "./BoardDetail.vue?vue&type=script&lang=js&"
export * from "./BoardDetail.vue?vue&type=script&lang=js&"
import style0 from "./BoardDetail.vue?vue&type=style&index=0&id=19be47a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19be47a3",
  null
  
)

export default component.exports